module.exports = __webpack_public_path__ + "static/media/texture (3).1c288c2c.jpg";